'use strict';

var template       = require('../../templates/payrollSubmissions/Main.html');
var SubmissionView = require('./Submission');

module.exports = Backbone.View.extend({

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            attachments: null
        });

        return this.render();
    },

    render: function() {
        this.$el.html(template({total: this.collection.length}));

        this.collection.each((payroll) => {
            var submissionView = new SubmissionView({
                model: payroll,
                attachments: this.options.attachments[payroll.id]
            });

            this.$('#submissions').append(submissionView.el);
        });

        return this;
    }
});



// WEBPACK FOOTER //
// ./app/adminManager/views/payrollSubmissions/Main.js